import React from 'react';
import { Facebook, Instagram, Phone } from 'lucide-react';

export const SocialBar = () => {
  const socialLinks = [
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/reseaudaideadomicile/',
      icon: <Facebook size={24} />,
      color: '#1877F2'
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/reseaudaideadomicile/',
      icon: <Instagram size={24} />,
      color: '#E4405F'
    },
    {
      name: '07 69 01 69 04',
      url: 'tel:0481119591',
      icon: <Phone size={24} />,
      color: '#2E7D32'
    },
    {
      name: '07 69 01 69 04',
      url: 'tel:0769016904',
      icon: <Phone size={24} />,
      color: '#1565C0'
    }
  ];

  return (
    <div className="social-bar">
      <div className="social-bar-label">Suivez-nous</div>
      {socialLinks.map((social, index) => (
        <a
          key={index}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className="social-bar-link"
          style={{ '--social-color': social.color }}
          aria-label={social.name}
        >
          {social.icon}
        </a>
      ))}
    </div>
  );
};
